export default function (module, entityId = null) {
  let window = `importador.upload`
  !this.$uloc.window.get(window) && this.$uloc.window.new({
    wid: window,
    title: 'Importação',
    width: '70%',
    height: '80%',
    minHeight: '500px',
    backdrop: true,
    clickOutside: false,
    windowClass: 'erp-window-modern',
    contentClass: '__overflow-hidden',
    props: {
      module: module,
      entityId: entityId
    }
  }, () => import('../components/importacao/ImportacaoUpload'))
    .then((wid) => {
      this.$uloc.window.listen(wid, {
        created: (wid, val) => {
          this.loadImportacoes && this.loadImportacoes()
        }
      })
    }) // return wid
}
